import { environment } from 'src/environments/environment';
import { OperatorId } from 'src/app/core/services/operator/models/operator-id';

// The tier list's "Local" card launches a game with no room, for testing. It is offered only
// outside production and only on THNDR's own operators, never on a customer's.
// The operator id comes as a reader, called only outside production: OperatorService.operatorId
// throws while the id is unset, and production must never pay that risk for a test-only card.
export function canShowLocalPlay(readOperatorId: () => string): boolean {
  if (environment.target === 'production') {
    return false;
  }
  const operatorId = readOperatorId();
  return operatorId === OperatorId.thndr || operatorId === OperatorId.fakebet;
}
